import { NgOptimizedImage } from '@angular/common';
import { Component, effect, inject } from '@angular/core';
import { ThemeService } from '@mmscan/design-system';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'mp-footer',
  imports: [ButtonModule, NgOptimizedImage, TranslatePipe],
  templateUrl: './footer.component.html',
})
export class FooterComponent {
  logoUrl = 'logos/logo-horizontal-black.svg';

  currentYear = new Date().getFullYear();

  private themeService = inject(ThemeService);

  constructor() {
    effect(() => {
      this.logoUrl =
        this.themeService.theme() === 'dark' ? 'logos/logo-horizontal-white.svg' : 'logos/logo-horizontal-black.svg';
    });
  }
}
